<template>
  <BlokkliProvider v-bind="blokkliProps">
    <Container class="mt-80 md:mt-60 xl:mt-90">
      <div class="relative">
        <div class="lg:w-8/12">
          <Tag
            color="bg-white"
            :text="$texts('pressRelease')"
            class="mb-5"
          />

          <h1
            v-if="title"
            class="text-3xl md:text-4xl lg:text-5xl xl:text-6xl mb-20 md:mb-30 font-semibold hyphens-auto break-words"
          >
            {{ title }}
          </h1>

          <div class="text-base uppercase">
            <DrupalDateTime
              v-if="created?.first"
              v-bind="created.first"
              class="mr-10"
            />
            <ArticleAuthors v-if="authors" :authors="authors" show-full />
          </div>

          <p
            v-if="lead"
            class="font-normal text-md md:text-lg mt-20 mb-20 md:mb-30 lg:mb-40"
          >
            {{ lead }}
          </p>

          <MediaImage
            v-if="image"
            v-bind="image"
            :image-style="imageStyle"
            class="md:float-right md:ml-15 md:mb-15 lg:absolute lg:top-0 lg:right-0 my-15 md:my-0"
          />
        </div>
        <BlokkliField name="field_paragraphs" :list="paragraphs" />
      </div>
      <BlokkliField
        :list="paragraphsFooter"
        field-list-type="footer"
        non-empty-class="paragraphs-field-list-footer"
        name="field_paragraphs_footer"
      />
    </Container>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodePressReleaseFragment } from '#graphql-operations'

defineProps<NodePressReleaseFragment>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    sm: 400,
    md: 260,
    xl: 370,
  },
})
</script>
